import * as surveys from './surveys.api';

const api = {
  surveys,
};

export default api;
export type ApiType = typeof api;
